<div>
  <app-breadcrumbs></app-breadcrumbs>
  <div [cfaLoading]="isLoading" class="store-number-toolbar">
    <button mat-raised-button (click)="getSite()" color="primary"
      id="store-number-search-button">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput (keydown.enter)="getSite()" [(ngModel)]="storeNumber" />
    </mat-form-field>
  </div>
  <div class="main-card-wrapper">
    <div class="card-section-1">
      @if (site != null) {
        <div>
          <mat-card>
            <mat-card-header>
              <mat-card-title>Mist Site {{site.name}}</mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content>
              <mat-slide-toggle [(ngModel)]="guestWifi">
                @if (guestWifi) {
                  <span>Guest WiFi Enabled</span>
                }
                @if (!guestWifi) {
                  <span>Guest WiFi Disabled</span>
                }
              </mat-slide-toggle>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  </div>
  @if (site != null) {
    <button id="submit-guest-wifi-button" mat-raised-button color="primary" (click)="updateGuestWifi()">Submit</button>
  }
</div>